<template>
    <div ref="appointmentContainer" style="width: 100%;">
        <h3 v-if="!checkContactID()">Contact is not an Open Dental patient.</h3>
        <div v-else>
            <h3>Appointments</h3>
            <div v-if="loading" style="display: flex; justify-content: center; margin-top: 10%;">
                <Loader />
            </div>
            <v-data-table-virtual v-else-if="appointmentsList.length > 0" :headers="filteredHeaders"
                v-model:expanded="expanded_apts"
                item-value="AptNum"
                :items="appointmentsList" :show-expand="filteredHeaders.length != appt_headers.length"
                :row-props="getRowProps">
                <template v-slot:[`item.date`]="{ item }">
                    <span v-if="item.AptStatus === 'UnschedList'">--</span>
                    <span v-else>
                        {{ item.AptDateTime.split(' ')[0].slice(5) }}
                        <sup style="font-size: 12px; color: gray;">
                            {{ item.AptDateTime.split(' ')[0].slice(2, 4) }}
                        </sup>
                    </span>
                </template>

                <template v-slot:[`item.day`]="{ item }">
                    <span v-if="item.AptStatus === 'UnschedList'">--</span>
                    <div v-else style="display: flex; flex-direction: column; align-items: center;">
                        <span>
                            {{ item.AptDateTime.split(' ')[1].slice(0, 5) }}
                            <sup style="font-size: 12px; color: gray;">
                                {{ days[new Date(item.AptDateTime).getDay()] }}
                            </sup>
                        </span>
                    </div>
                </template>

<template v-slot:[`item.action`]="{ item }">
  <div style="display: flex; justify-content: center;">
    <v-progress-circular
      v-if="confirmingAptNum === item.AptNum"
      indeterminate
      color="primary"
      size="20"
      width="2"
    />
    <v-tooltip v-else :text="item.confirmed === 'Unconfirmed' ? 'Confirm Appointment' : 'Appointment Confirmed'">
      <template #activator="{ props }">
        <v-icon
          v-bind="props"
          v-if="item.AptStatus == 1 || item.confirmed === 'Unconfirmed'"
          @click="conformappt(item)"
          color="primary"
        >
          mdi-calendar-check
        </v-icon>
        <v-icon
          v-bind="props"
          v-else
          color="green"
          style="opacity: 0.6; cursor: not-allowed;"
        >
          mdi-check-circle
        </v-icon>
      </template>
    </v-tooltip>
  </div>
</template>
                <template v-slot:item.data-table-expand="{ item }">
                    <v-btn :icon="expanded_apts.includes(item.AptNum) ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                        size="small" variant="plain" @click="toggleExpand(item)">
                    </v-btn>
                </template>

                <template v-slot:expanded-row="{ item }">
                    <tr>
                        <td>
                            <div v-if="filteredHeaders.length<=2">
                                <strong >Provider :</strong>{{ item.provAbbr }} <br />
                            </div>
                            <div v-if="filteredHeaders.length<=3">
                                <strong>Notes:</strong> {{ item.Note }} <br />
                            </div>
                            <div v-if="filteredHeaders.length<=4">
                                <strong>Procedures:</strong> {{ item.ProcDescript }}
                            </div>                  
                        </td>
                    </tr>
                </template>
            </v-data-table-virtual>
            <h3 v-else>No Appointments to Show!</h3>
        </div>

    </div>
</template>

<script>
import OdService from "@/services/odService";
import Loader from '../../UIComponents/Loader.vue';
import EventBus from "../../../eventBus";
export default {
    name: "AppointmentDetails",
    data() {
        return {
 appt_headers: [
    { title: "Date", key: "date" },
    { title: "Time", key: "day" },
    { title: "Provider", key: "provAbbr" },
    { title: "Notes", key: "Note" },
    { title: "Procedures", key: "ProcDescript" },
    { title: "Action", key: "action", sortable: false } 
],
            days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            expanded_apts: [],
            appointmentsList: [],
            loading: true,
            containerWidth: 0,
            confirmingAptNum: null
        };
    },

    computed: {
filteredHeaders() {
    let headers;

    if (this.containerWidth > 600) {
        this.expanded_apts = [];
        headers = this.appt_headers;
    } else if (this.containerWidth > 500) {
        headers = this.appt_headers.filter(h => h.key !== "ProcDescript");
    } else if (this.containerWidth > 300) {
        headers = this.appt_headers.filter(h => !["ProcDescript", "Note"].includes(h.key));
    } else {
        headers = this.appt_headers.filter(h => ["date", "day"].includes(h.key));
    }
    if (!headers.find(h => h.key === "action")) {
        headers.push({ title: "Action", key: "action", sortable: false });
    }

    return headers;
}
    },

    components: { Loader },

    props: {
        contact: { type: Object, default: null }
    },

    watch: {
        async contact() {
            await this.fetchAppointments();
        },

    },

    methods: {
        async conformappt(item){
            this.confirmingAptNum = item.AptNum;
            let payload = {
                AptNum:item.AptNum,
                patNum:item.PatNum,
                apptnote: item.Note
            }
            try {
                let res = await OdService.confirmedAppointment(payload);
                if(res.status==200){
                    EventBus.$emit("show-snackbar", { message: "Appointment Confirmed!", color: "success" });
                    const index = this.appointmentsList.findIndex(a => a.AptNum === item.AptNum);
                    if (index !== -1) {
                        this.appointmentsList[index] = { ...this.appointmentsList[index], confirmed: 'Confirmed' };
                    }
                } else {
                    EventBus.$emit("show-snackbar", { message: "Failed to Confirm Appointment.", color: "error" });
                }
            } finally {
                this.confirmingAptNum = null;
            }
        },
        checkContactID() {
            return this.contact && this.contact.OD_PatNum;
        },
        toggleExpand(item) {
            const index = this.expanded_apts.findIndex(apt => apt === item.AptNum);
            if (index > -1) {
                this.expanded_apts.splice(index, 1);
            } else {
                this.expanded_apts.push(item.AptNum);
            }
        },
        getRowProps({ item }) {
            if (item.AptStatus === 'UnschedList') return { class: 'row-unscheduled' };
            const aptDate = new Date(item.AptDateTime);
            const today = new Date();
            aptDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
            if (aptDate.getTime() === today.getTime()) return { class: 'row-today' };
            if (aptDate > today) return { class: 'row-future' };
            return {};
        },
        onResize(entries) {
            requestAnimationFrame(() => {
                entries.forEach(entry => {
                    this.containerWidth = entry.contentRect.width;
                });
            });
        },
        async fetchAppointments() {
            if (!this.checkContactID()) return;
            this.loading = true;
            try {
                let apt_list = await OdService.getContactAppointments(this.contact.contact_id);
                this.appointmentsList = Array.isArray(apt_list?.data) ? apt_list.data : [];
            } catch (error) {
                console.error(error);
                this.appointmentsList = [];
            } finally {
                this.loading = false;
            }
        }
    },

    async mounted() {
        this.resizeObserver = new ResizeObserver(this.onResize);
        if (this.$refs.appointmentContainer) {
            this.resizeObserver.observe(this.$refs.appointmentContainer);
        }
        await this.fetchAppointments();
    },

    beforeUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
};
</script>

<style>
.row-unscheduled td {
    background-color: rgba(211, 47, 47, 0.12) !important;
    color: #d32f2f;
    font-weight: bold;
}
.row-today td {
    color: #ff9800;
    font-weight: bold;
}
.row-future td {
    color: #2e7d32;
    font-weight: 600;
}
</style>